import dayjs, { Dayjs } from "dayjs";
import { IApplicationData } from "../../model/application-data";
import { IAuthenticationData } from "../../model/authentication-data";
import { IAuthenticationResponse } from "../../model/security/response/authentication-response";

// const defaultTestApplicationData = {
//     multitenant: 1, //MUNIDADOS
//     moduleId: 1,
//     moduleName: "SERP",
//     securityUrl: 'http://localhost:5050/',
//     officialDailyUrl: "http://localhost:5062/",
//     publicationShipmentUrl: "http://localhost:5129",
//     municipalPortalUrl: "http://localhost:5003",
//     // securityUrl: "https://api-security-dev.munidados.com.br",
//     // officialDailyUrl: "https://api-officialdaily-dev.munidados.com.br",
//     // publicationShipmentUrl: "https://api-publicationshipment-dev.munidados.com.br",
//     // municipalPortalUrl: "https://api-municipalportal-dev.munidados.com.br",
//     imageLogo: "/img/logo_scp.png",
//     initialPage: "dashboard",
//     moduleDescription: "Envio de Remessas de Publicação",
// } as IApplicationData;


const defaultTestApplicationData = {
    multitenant: 1, //MUNIDADOS
    moduleId: 2,
    moduleName: "SPDO",
    securityUrl: 'http://localhost:5050/',
    officialDailyUrl: "http://localhost:5062/",
    publicationShipmentUrl: "http://localhost:5129",
    municipalPortalUrl: "http://localhost:5003",
    // securityUrl: "https://api-security-dev.munidados.com.br",
    // officialDailyUrl: "https://api-officialdaily-dev.munidados.com.br",
    // publicationShipmentUrl: "https://api-publicationshipment-dev.munidados.com.br",
    // municipalPortalUrl: "https://api-municipalportal-dev.munidados.com.br",
    imageLogo: "/img/logo_scp.png",
    initialPage: "dashboard",
    moduleDescription: "Diagramação de Diário Oficial",
} as IApplicationData;

// const defaultTestApplicationData = {
//     multitenant: 1, //MUNIDADOS
//     moduleId: 3,
//     moduleName: "SGAP",
//     securityUrl: 'http://localhost:5050/',
//     // officialDailyUrl: "http://localhost:5062/",
//     publicationShipmentUrl: "http://localhost:5129",
//     municipalPortalUrl: "http://localhost:5003/",
//     // securityUrl: "https://api-security-dev.munidados.com.br",
//     officialDailyUrl: "https://api-officialdaily-dev.munidados.com.br",
//     // publicationShipmentUrl: "https://api-publicationshipment-dev.munidados.com.br",
//     // municipalPortalUrl: "https://api-municipalportal-dev.munidados.com.br",
//     imageLogo: "/img/logo_scp.png",
//     initialPage: "banners",
//     moduleDescription: "Administração do Portal do Municipio",
// } as IApplicationData;


const getApplicationData = (): IApplicationData => {

    var applicationData = {} as IApplicationData;
    applicationData.multitenant = 1;
    applicationData.securityUrl = "https://api-security.munidados.com.br";
    applicationData.officialDailyUrl = "https://api-officialdaily.munidados.com.br";
    applicationData.publicationShipmentUrl = "https://api-publicationshipment.munidados.com.br";
    applicationData.municipalPortalUrl = "https://api-municipalportal.munidados.com.br";

    var url = window.location.hostname.toLowerCase();
    if (url.includes("serp")) {
        applicationData.moduleId = 1
        applicationData.moduleName = "SERP"
        applicationData.imageLogo = "/img/logo_sdp.png";
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Envio de Remessas de Publicação";
    } else if (url.includes("spdo")) {
        applicationData.moduleId = 2
        applicationData.moduleName = "SPDO"
        applicationData.imageLogo = "/img/logo_sdp.png";
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Diagramação de Diário Oficial";
    } else if (url.includes("portal-admin")) {
        applicationData.moduleId = 3
        applicationData.moduleName = "SGAP"
        applicationData.imageLogo = "/img/logo_sdp.png";
        applicationData.initialPage = "banners";
        applicationData.moduleDescription = "Administração do Portal do Municipio";
    }

    if (url.includes("-dev")) {
        applicationData.securityUrl = "https://api-security-dev.munidados.com.br";
        applicationData.officialDailyUrl = "https://api-officialdaily-dev.munidados.com.br";
        applicationData.publicationShipmentUrl = "https://api-publicationshipment-dev.munidados.com.br";
        applicationData.municipalPortalUrl = "https://api-municipalportal-dev.munidados.com.br";

    } else if (url.includes("localhost")) {
        applicationData = defaultTestApplicationData;
    }
    document.title = `${applicationData.moduleName} - ${applicationData.moduleDescription}`;
    return applicationData;
};

const getAuthenticationData = (): IAuthenticationData | undefined => {
    let value = localStorage.getItem("session_authentication") as string;
    return JSON.parse(value);
};

const setExpireTime = (time: Dayjs) => {
    let authenticationData = getAuthenticationData();

    if (authenticationData !== undefined) {
        authenticationData.expireTime = time;
        setAuthenticationData(authenticationData);
    }
};

const setAuthenticationData = (data: IAuthenticationResponse): IAuthenticationData | undefined => {
    let authenticationData = Object.assign({} as IAuthenticationData, data);
    if (authenticationData !== undefined) {
        authenticationData.expireTime = dayjs().add(10, 'minutes');
    }
    localStorage.setItem("session_authentication", JSON.stringify(authenticationData));

    return authenticationData;
};

const clearAuthenticationData = () => {
    localStorage.removeItem("session_authentication");
};


const ApplicationAppService = {
    getAuthenticationData, setAuthenticationData, clearAuthenticationData, getApplicationData, setExpireTime
};

export default ApplicationAppService;